import React from 'react'
import './Preloader.scss'
import OlimpLogo from '../../assets/images/logo_square.png'

const Preloader: React.FC = () => {
    return (
        <div className="preloader">
            <div className="preloader__content">
                <img src={OlimpLogo} width={100} alt="OLIMP" className="preloader__logo" />
                <div className="preloader__glow"></div>
            </div>
        </div>
    )
}

export default Preloader
